/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'
axios.defaults.headers.common['Accept'] = 'application/json'

export default {
  getStatus({ rootState, commit, dispatch }, axiosConfig = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${rootState.baseURL}/statuses`, axiosConfig)
        .then((response) => {
          commit('setStatuses', response.data.statuses)
          dispatch('createFormTypeStatusObject')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  createFormTypeStatusObject(context) {
    let attributes={}
    context.state.statuses.forEach((formType) => {
      attributes[formType.id] = []
      formType.statuses.forEach((status) => {
        attributes[formType.id].push(status) 
      })
    })
    context.commit('setFormTypeStatuses',attributes)
  },
}
